import format from "date-fns/format";

export default function defaultDateFormat(date: Date = new Date()) {
  if (!date) return "";
  return format(date, "MM/dd/yyyy");
}

export function defaultDateTimeFormat(date: Date = new Date()) {
  if (!date) return "";
  return format(date, "MM/dd/yyyy h:mm:ss aa");
}
